export default __webpack_public_path__ + "088e698032c0a4c44fe80bb2e53d3433.png";